module.exports = __webpack_public_path__ + "static/track-mobile-bg-02b40500935b5dd3b229ab6ae8bd3724.png";